export default __webpack_public_path__ + "static/barygul-440366fdef2819ff254e5ed8ce4f8f9b.jpg";